var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.46,
    height: 55.46,
    viewBox: "0 0 134.485 55.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2768.442 -453.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.078,27.427H96.386V0H-1.078Z",
    transform: "translate(2787.934 453.732)",
    fill: "#e3ebe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.987-21.043,198.8,10.9V-16.527L181.987-43.982Z",
    transform: "translate(2702.333 497.369)",
    fill: "#e3ebe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8-20.835,181.987,11.108V-16.319L198.8-43.43Z",
    transform: "translate(2588.055 497.161)",
    fill: "#e3ebe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.755-.123l97.5.077,16.762,27.228H-1.078Z",
    transform: "translate(2771.12 462.737)",
    fill: "#7fc2f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.078,2.584H96.386V0H-1.078Z",
    transform: "translate(2787.934 453.387)",
    fill: "#848e8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.987-41.4l18.13,28.764v-3.081l-18.13-28.264Z",
    transform: "translate(2702.333 497.369)",
    fill: "#848e8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.218-41.382l-17.783,28.87v-3.081l17.783-28.39Z",
    transform: "translate(2588.638 497.369)",
    fill: "#848e8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.078,24.157h.224V0h-.224Z",
    transform: "translate(2787.934 453.387)",
    fill: "#848e8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.078,24.157h.224V0h-.224Z",
    transform: "translate(2885.175 453.387)",
    fill: "#848e8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,97.352H.224V0H0Z",
    transform: "translate(2786.856 477.766) rotate(-90)",
    fill: "#848e8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.755-.123l97.5.077,16.762,27.228H-1.078Z",
    transform: "translate(2771.12 462.737)",
    fill: "#7fc2f3",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2791.694 466.221)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.642,54.476a35.626,35.626,0,0,1,2.406-2.891c.9-.874.6-1.363-.334-1.808-1.687-.8-3.379-1.592-5.062-2.4-.241-.116-.577-.158-.652-.629a17.522,17.522,0,0,1,7.108,2.32c1.467.94,1.435,2.045.062,3.081-.914.69-1.794,1.426-2.7,2.128a3.617,3.617,0,0,1-.828.2",
    transform: "translate(9.246 -37.827)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.242,40.775c-.274,1.676.595,3.473-.83,5.042a2.676,2.676,0,0,1-1.965,1,25.907,25.907,0,0,1-7-.717,19.941,19.941,0,0,1,5.363-.705c2.94,0,3.1-.143,3.6-3.044a16.473,16.473,0,0,1,.45-1.629l.386.048",
    transform: "translate(-58.836 -34.054)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.158,57.026a37.024,37.024,0,0,1,4.476-.919,8.229,8.229,0,0,1,5.639,1.707c.784.589.875,1.792.605,3.227-1.477-3.736-4.5-3.5-7.382-3.61-1.066-.04-2.188.263-3.337-.4",
    transform: "translate(-20.197 -56.08)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.859,41.612c-2.521-.289-5.359.5-7.122-2.283A2.35,2.35,0,0,1,58,36a6.249,6.249,0,0,0,.663-.917,1.392,1.392,0,0,1-.006,1.076q-.8,2.917,2.167,3.9c1.368.45,2.851.59,4.032,1.562",
    transform: "translate(-57.173 -31.673)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.525,62.521c2.944-.146,5.692-2.295,8.807-.689-2.934.245-5.684,2.369-8.807.689",
    transform: "translate(-46.166 -54.567)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.525,62.521c2.944-.146,5.692-2.295,8.807-.689-2.934.245-5.684,2.369-8.807.689",
    transform: "translate(-71.178 -50.964)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.347.686c3.017.039,6.065-1.72,9.014.248C49.353.6,46.308,2.714,43.347.686",
    transform: "translate(-37.059 0.904)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.553,74.161A9.257,9.257,0,0,0,60.921,78.2a2.077,2.077,0,0,1-2.428.9,5.544,5.544,0,0,0,2.048-2.648c.825-1.882,2.37-2.609,5.011-2.286",
    transform: "translate(-36.078 -67.415)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.882,11.961c2.784.654,5.92-.85,8.421,1.418-2.8-.524-5.857.559-8.421-1.418",
    transform: "translate(-55.829 -11.549)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.021,49.8c2.329-1.4,4.224-1.125,5.7.609.062.073.119.15.183.22.357.388,1.352.579.949,1.172s-1.123-.076-1.657-.336c-.8-.388-1.341-1.205-2.377-1.225a21.538,21.538,0,0,1-2.795-.44",
    transform: "translate(-38.401 -47.075)",
    fill: "#61a0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.225,70.344a4.918,4.918,0,0,0,1.522.26c1.418.244,2.684,2.458,2.124,3.676-.134.292-.372.268-.573.081-.243-.225-.591-.452-.656-.733a3.379,3.379,0,0,0-2.657-2.508c-.277-.084-.6-.205-.5-.559.1-.379.457-.224.744-.216",
    transform: "translate(-62.345 -60.206)",
    fill: "#61a0f3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-.641,27.785H130.451V.318H-.641Z",
    transform: "translate(2770.956 481.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66,
    cy: 1.66,
    r: 1.66,
    transform: "translate(2899.607 481.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.245,
    cy: 1.245,
    r: 1.245,
    transform: "translate(2900.437 506.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.075,
    cy: 1.66,
    rx: 2.075,
    ry: 1.66,
    transform: "translate(2768.442 481.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.245,
    cy: 1.245,
    r: 1.245,
    transform: "translate(2769.272 506.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.078.992H130.56V0H-1.078Z",
    transform: "translate(2770.847 485.061)",
    fill: "#e3ebe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.078.992H130.161V0H-1.078Z",
    transform: "translate(2771.246 505.335)",
    fill: "#e3ebe8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.ebfcedf69fdca017dbd9673e4acff060.svg";
export { ForwardRef as ReactComponent };